import { render, staticRenderFns } from "./VerifyCode.vue?vue&type=template&id=a5bd7e88&scoped=true&"
import script from "./VerifyCode.vue?vue&type=script&lang=js&"
export * from "./VerifyCode.vue?vue&type=script&lang=js&"
import style0 from "./VerifyCode.vue?vue&type=style&index=0&id=a5bd7e88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bd7e88",
  null
  
)

export default component.exports